import { useState } from "react";

// Reuse failure knowledge across reading modes instead of repeatedly hitting a
// broken publisher URL. A later visit can retry after the short cooldown.
const failures = new Map();
const RETRY_AFTER_MS = 5 * 60 * 1000;

export const useArticleImage = (image) => {
  const [failedImage, setFailedImage] = useState(null);
  const valid = typeof image === "string" && /^https?:\/\//i.test(image);
  const recentlyFailed = failures.has(image) && Date.now() - failures.get(image) < RETRY_AFTER_MS;
  const onError = () => {
    failures.set(image, Date.now());
    if (failures.size > 200) failures.delete(failures.keys().next().value);
    setFailedImage(image);
  };
  return { available: valid && image !== failedImage && !recentlyFailed, onError };
};